<template>
    <y-panel-grid :service="$services.Icib.userFollowingsGrid" />
</template>

<script>

    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'PlansGrid',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        breadcrumbs() {
            return [
                this.$bc('dashboard', this.$t('breadcrumbs.dashboard')),
                this.$bc('icib-organizations-list', this.$t('breadcrumbs.organizations')),
            ];
        },

    };

</script>
